import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './icons/Icon';
import './CtaBand.css';

const CtaBand = () => (
  <section className="cta-band" aria-label="Book an appointment">
    <div className="cta-band-inner">
      <div className="cta-band-text">
        <span className="cta-band-eyebrow">Your smile matters</span>
        <h2>Ready for a healthier, brighter smile?</h2>
        <p>Book a visit with Dr. Muyabin in Dar es Salaam — gentle care, modern dentistry.</p>
      </div>
      <div className="cta-band-actions">
        <Link to="/appointment" className="cta-band-btn cta-band-btn--primary">
          <Icon name="calendar" size={18} />
          Book Appointment
        </Link>
        <Link to="/contact" className="cta-band-btn cta-band-btn--ghost">
          Contact Us
        </Link>
      </div>
    </div>
  </section>
);

export default CtaBand;
